import { SelectedRoleEnum } from '@/store/types'
import { createContext } from 'react'

import { TimeRange } from '../../types'

import { SemesterInfo } from './types'

export const DataBoardContext = createContext<{
  timeRange: TimeRange
  semesterInfo: SemesterInfo
  role: SelectedRoleEnum | undefined
}>(null as any)
